import {
  ELEMENT_TYPE_DESIGN,
  ELEMENT_TYPE_TEXT,
  ELEMENT_TYPE_UPLOAD
} from '@/plugins/composition-renderer/constants';

export const PRINT_STYLE_DTG = 'Digital';
export const PRINT_STYLE_DTF = 'DTF';
export const PRINT_STYLE_FLEX = 'Flex';
export const PRINT_STYLE_FLOCK = 'Flock';
export const PRINT_STYLE_CUP_PRINT = 'CupPrint';
export const PRINT_STYLE_SUBLIMATION = 'Sublimation';

export const PRINT_STYLES_ALL = [
  PRINT_STYLE_DTG,
  PRINT_STYLE_DTF,
  PRINT_STYLE_FLEX,
  PRINT_STYLE_FLOCK,
  PRINT_STYLE_CUP_PRINT,
  PRINT_STYLE_SUBLIMATION
];
export const PRINT_STYLES_PIXEL = [
  PRINT_STYLE_DTG,
  PRINT_STYLE_DTF,
  PRINT_STYLE_CUP_PRINT,
  PRINT_STYLE_SUBLIMATION
];

export const ELEMENT_PRINTSTYLES_ALLOWED = {
  [ELEMENT_TYPE_TEXT]: PRINT_STYLES_ALL,
  [ELEMENT_TYPE_DESIGN]: PRINT_STYLES_PIXEL,
  [ELEMENT_TYPE_UPLOAD]: PRINT_STYLES_PIXEL
};

export const CAPABILITY_FONT_EFFECT = 'efx';
export const CAPABILITY_FONT_EFFECT_COLOR = 'efx-color';
export const CAPABILITY_FONT_EFFECT_ANGLE = 'efx-angle';
